import React, { useMemo } from 'react';

import type { SearchAllContentHit } from '../types';

import './style.scss';

const SearchAllContentAutosuggestHit: React.FC<{ hit: SearchAllContentHit }> = ({ hit }) => {
  const [title, body, author] = useMemo(() => [
    // Page_title for nodes, name for taxonomy terms, colleague_full_name for profiles.
    hit.page_title?.[0] || hit.name?.[0] || hit.colleague_full_name?.[0],
    // Body summarized for nodes, description for taxonomy terms.
    hit.body?.[0] || hit.description?.[0],
    // Author full name for nodes, contact person full name for taxonomy terms.
    hit.author_full_name?.[0] || hit.contact_person_full_name?.[0],
  ], [hit]);

  if (!title) {
    return null;
  }

  return (
    <div className="SearchAllContent__AutosuggestHit">
      <div className="SearchAllContent__AutosuggestHit__title">
        {title}
      </div>

      {author && (
        <div className="SearchAllContent__AutosuggestHit__author mt-1 mb-0">
          {author}
        </div>
      )}

      {body && (
        <div className="SearchAllContent__AutosuggestHit__body u-truncate--3 mt-1">
          {body}
        </div>
      )}
    </div>
  );
};

export default SearchAllContentAutosuggestHit;
